import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { OrderingForm } from "../components/Form";

export default function Product() 
{

  const info = [
    { title: "IA générative", desc: "Le chatbot intelligent d’Agrospace ( Jaari bot ) fournit des réponses personnalisées aux questions agricoles et aide à automatiser certaines tâches pour faciliter l’accès à l’information.", icon: "bi bi-check-circle-fill" },
    { title: "Text to Speech", desc: "Le chatbot d’Agrospace intègre un système multilingue capable de traduire en audio, dans les langues locales, les réponses et textes générés par le chatbot. Cela permet aux utilisateurs de recevoir des conseils agricoles clairs et accessibles, même dans leur langue maternelle.", icon: "bi bi-check-circle-fill" },
    { title: "Monitoring", desc: "Permet de collecter, visualiser et fournir l’historique des données sur les cultures, l’irrigation et les ressources, afin d’optimiser la gestion des exploitations. Cette gestion est pilotée par notre modèle d’IA, dont les réponses s’adaptent aux besoins des utilisateurs et sont exécutées directement par les edge-contrôleurs que nous proposons.", icon: "bi bi-check-circle-fill" },
    { title: "Edge controleur", desc: "Agrospace propose également un edge-controller permettant de gérer de manière intelligente et efficace les équipements d’arrosage, connecté à notre système via la plateforme pour une irrigation fiable et optimisée.", icon: "bi bi-check-circle-fill" },
    { title: "Réseautage", desc: "Agrospace propose un réseau social agricole où les utilisateurs partagent informations, communiqués et opportunités. Des sessions de discussion thématiques permettent également d’échanger et de collaborer entre acteurs du secteur.", icon: "bi bi-check-circle-fill" },
    { title: "Marché virtuel", desc: "Agrospace intègre un marché en ligne dédié à l’agriculture, permettant la vente et l’achat de produits, d’équipements agricoles et de services d’expertise, favorisant ainsi des échanges commerciaux simples et accessibles.", icon: "bi bi-check-circle-fill" },
  ];

  const Service = [
    { title: "Autentification", desc: "Agrospace garantit un accès sécurisé grâce à un système d’authentification fiable, permettant aux utilisateurs de se connecter facilement tout en protégeant leurs données personnelles et professionnelles.", icon: "bi bi-person-check" },
    { title: "Securité", desc: "La plateforme met en place des protocoles de sécurité avancés pour assurer la confidentialité des informations, prévenir les intrusions et protéger les échanges entre utilisateurs.", icon: "bi bi-shield-check" },
    { title: "Fiabilité", desc: "Agrospace repose sur une infrastructure robuste qui garantit la disponibilité des services, la continuité des activités et la précision des données fournies aux utilisateurs et acteurs du secteur.", icon: "bi bi-patch-check" },
    { title: "Space de travail", desc: "La plateforme offre un espace de travail ergonomique et collaboratif où les utilisateurs peuvent accéder à l’ensemble des applications, gérer leurs activités agricoles et interagir avec la communauté de manière fluide.", icon: "bi bi-laptop" },
  ];

  return (
    <div className="bg-light min-vh-100">
      {/* Header's section */}
      <Header page={2} />

      {/* Agrospace description section */}
      <section className="hero-wrap-row">
        <div className="container d-flex justify-content-center align-items-center py-5" >
          <div className="row align-items-center py-5 px-2">
            {/* Text content on the left */}
            <div className="col-lg-5 mb-4 mb-lg-0 py-4">
              <p className="text-dark h1 fw-bold mb-3"> Plateforme Agrospace </p>
              <p className="lead text-muted mx-auto">
                Agrospace regroupe des applications agricoles pour informer, conseiller et suivre les exploitations en temps réel, tout en favorisant la collaboration entre acteurs du secteur.
              </p>
              <div className="d-flex mt-3">
                <a className="btn btn-lg btn-outline-dark d-flex align-items-center" href="#edge">
                  Plus d'information <i className="bi bi-arrow-right ms-2"></i>
                </a>
              </div>
            </div>
            <div className="col-lg-1"></div>
            {/* Image placeholder on the right */}
            <div className="col-lg-6 py-3">
              <div className="d-flex justify-content-end">
                <img src="../img/product.png" alt="icon-agrospace" className="img-fluid rounded-3"/>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="text-center py-5 mt-5 px-3">
        <h1> Présentation de nos produits </h1>
      </div>

      {/* Popular Pages */}
      <div className="container pb-5 pt-4 px-3">
        <div className="row g-4 pb-5">
          {info.map((item, idx) => (
            <div className="col-lg-4 col-md-6 mb-4" key={idx}>
              <div className="d-flex align-items-center mb-3">
                <div className="fs-4 text-success me-2">
                  <i className={item.icon}></i>
                </div>
                <h4>{item.title}</h4>
              </div>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Edge controler section */}
      <div className="container-fluid bg-green-light d-flex justify-content-center align-items-center py-5" id="edge" >
        <div className="row align-items-center py-5 px-2">
          {/* Text content on the left */}
          <div className="col-lg-5 mb-4 mb-lg-0 py-4">
            <p className="text-dark h1 fw-bold mb-3"> Présentation du controleur </p>
            <p className="lead text-muted mx-auto">
              Agrospace propose également un edge-controller permettant de gérer de manière intelligente et efficace les équipements d’arrosage.
            </p>
          </div>
          <div className="col-lg-1"></div>
          {/* Video placeholder on the right */}
          <div className="col-lg-6 border py-3">
            <div className="embed-responsive embed-responsive-16by9 bg-light rounded shadow-sm d-flex justify-content-center align-items-center" style={{ height: '350px' }}>
              <iframe className="embed-responsive-item" src="https://www.youtube.com/embed/m1xg_6SkJkk?si=R21MokrVLijcW0q7" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>


      {/* Form's section */}
      <div className="container-fluid py-5" >
        <div className="row justify-content-center py-5 px-2">
          {/* Text content on the left */}
          <div className="col-lg-4 mb-4 mb-lg-0 py-4">
            <p className="text-dark display-5 mb-3"> Faites vos commandes d'Edge-controleurs </p>
            <p className="lead text-muted mx-auto">
              Après soumission, votre commande sera prise en charge par notre équipe commerciale, qui vous contactera pour finaliser les modalités de paiement et de livraison.
            </p>
          </div>
          <div className="col-lg-2"></div>
          {/* Video placeholder on the right */}
          <div className="col-lg-5 border">
            <div className="d-flex flex-column py-5 px-2">       
               <OrderingForm />
            </div>
          </div>
        </div>
      </div>


      {/* Bootom's section */}
      <div className="container-fluid px-3 py-5 bg-gray-light" >
        <div className="row justify-content-center px-2 py-5">
          {/* Text content on top*/}
          <div className="col-lg-7 text-center mb-4 mb-lg-0 py-4 border">
            <p className="text-dark h1 fw-bold mb-3"> Plateforme Agrospace </p>
            <p className="lead text-muted mx-auto">
             Que vous souhaitiez accéder à vos applications agricoles, sécuriser vos données, garantir la fiabilité de vos activités ou collaborer efficacement dans un espace unique, Agrospace vous offre toutes les solutions nécessaires pour une gestion moderne et connectée.
            </p>
          </div>
        </div>
        <div className="row py-5">
            {Service.map((item, idx) => (
            <div className="col-lg-3 col-md-6" key={idx}>
              <div className="d-flex gap-3 flex-column mb-3 border rounded-4 bg-white p-4 shadow-active">
                <div className="fs-1 text-success me-2">
                  <i className={item.icon}></i>
                </div>
                <h4 className="text-muted">{item.title}</h4>
                <p className="text-muted">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>


    {/* Footer's section */}
    <Footer />
      
  </div>
  );
}
